import { FileEntity } from '@/shared/interfaces';
import { ThumbnailItem } from './ThumbnailItem';
import { cn } from '@/lib/cn';

type ThumbnailStripProps = {
    files: FileEntity[];
    currentIndex: number;
    onSelect: (index: number) => void;
};

export const ThumbnailStrip = ({
    files,
    currentIndex,
    onSelect,
}: ThumbnailStripProps) => {
    return (
        <div className="flex shrink-0 justify-center gap-2 px-4 py-3">
            {files.map((fileEntity, index) => (
                <button
                    key={fileEntity.identifier}
                    type="button"
                    className={cn(
                        'h-14 w-14 shrink-0 cursor-pointer overflow-hidden rounded-xl border-2 bg-transparent p-0 transition-opacity',
                        index === currentIndex
                            ? 'border-white opacity-100'
                            : 'border-transparent opacity-50 hover:opacity-80',
                    )}
                    aria-label={fileEntity.fileName}
                    aria-current={index === currentIndex}
                    onClick={() => onSelect(index)}
                >
                    <ThumbnailItem fileEntity={fileEntity} />
                </button>
            ))}
        </div>
    );
};
